import { Listbox } from "@headlessui/react";
import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const Dropdown = ({ selected, onChange, disabled, options }) => {
  return (
    <div className="relative w-[480px] text-teal-200">
      <Listbox
        disabled={disabled}
        value={selected.value}
        onChange={onChange}
        className=""
      >
        {({ open }) => (
          <>
            <Listbox.Button
              className={
                "w-full space-x-6 border-[1px] rounded-[4px] border-gray-100 text-left px-4 py-3 text-body-md flex items-center justify-between"
              }
            >
              <span className="text-gray-800 text-body-md font-semibold text-[16px]">{selected?.label}</span>
              {!disabled && (
                <div className="flex flex-col">
                  <span>
                    <ChevronDownIcon
                      className={`w-5 transform transition-all text-gray-600
                        ${open 
                        ? "-rotate-180" 
                        : ""
                        }`}
                    />
                  </span>
                </div>
              )}
            </Listbox.Button>
            <Listbox.Options
              className={`absolute w-full border-[1px] rounded-[4px] border-gray-100 left-0 bg-white shadow-lg top-[52px] z-[1] rounded-t-0 overflow-auto max-h-75`}
            >
              {options &&
                options?.map((option, index) => (
                  <Listbox.Option key={index} value={option} >
                    {({ active, selected }) => (
                      <div
                        className={`text-sm text-gray-800 py-2.5 px-3 cursor-pointer hover:bg-blue-100 
                          ${active 
                          ? "activeClass" 
                          : ""
                          } 
                          ${selected 
                            ? "bg-REELTeal text-white" 
                            : ""
                          }`}
                      >
                        {option.label}
                      </div>
                    )}
                  </Listbox.Option>
                ))}
            </Listbox.Options>
          </>
        )}
      </Listbox>
    </div>
  );
};

export default Dropdown;
